module.exports = __webpack_public_path__ + "img/d200908-2.4af93612.jpg";